<template>
  <div>
    <div class="top">
      <div class="container" style="position: relative">
        <div class="left">
          <span class="fontSize24">平台介绍</span>
        </div>
        <div class="right">
          <div class="textTips">
            <p>
              招采金服平台是上海汇招信息技术有限公司（下称“易招标”）创设的招标采购领域保函业务综合服务平台，一直专注于解决中小企业在招投标领域融资难题。平台于2019年5月上线，由易招标的全资子公司招采进宝（上海）信息技术有限公司主要运营，目前已实现电子投标保函业务全线上操作，能够实现7*24小时在线秒开电子保函，具备电子签章、保函验证、扫码支付等多个便捷的功能。
            </p>
            <br />
            <p>
              平台不断创新业务模式和服务理念，运用互联网信息技术及数据分析等手段，为投标人提供高效、低成本的信息渠道、交易渠道。
            </p>
            <br />
            <p>
              平台整合包括中国建设银行、阳光保险、华商担保等多种担保机构提供保函服务，同时，平台与多家公共资源交易系统及招标采购平台实现系统对接，方便投标人在线办理业务。已对接的平台包括：招采进宝河北专区平台、招采进宝山西专区平台、齐鲁采购与招标网等。 投标人在交易平台投标时可直接跳转到招采金服平台申请保函，并可自行选择出具保函的机构为其提供担保。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="container">
        <div class="description">
          <div><h1 class="fontSize24">团队介绍</h1></div>
          <div>
            招采金服平台拥有由多个专业的技术、客服、平台运营等人员组成的团队，负责平台的开发、建设、运营等工作，并主要在政府采购领域及工程建设领域开展相关保函业务推广。整个招采金服团队的使命是建设连接投标人和担保机构的桥梁，为投标人寻找更为专业可靠的担保机构，打造更为简单高效的保函申请服务平台。
          </div>
        </div>
        <div class="bgClass">
          <img src="../../assets/images/aboutUs/bg2.png" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div style="padding: 10px 0; text-align: center; padding-top: 4.9%">
          <h1 class="fontSize24">平台优势</h1>
        </div>
        <div class="advantage">
          <div class="advantageItem">
            <div class="imgIcon">
              <img
                class="itemicon"
                src="../../assets/images/aboutUs/clock.png"
              />
            </div>
            <div class="title"><h3>便捷高效</h3></div>
            <div class="detail">
              电子保函全流程在线出函，CA软证书签章，一键自动出函，全程在线处理，不受地点、时间限制。
            </div>
          </div>
          <div class="advantageItem">
            <div class="imgIcon">
              <img
                class="itemicon"
                src="../../assets/images/aboutUs/survive.png"
              />
            </div>
            <div class="title"><h3>服务丰富</h3></div>
            <div class="detail">
              投标保函、履约保函已实现在线申请；预付款保函、质量保函、农民工工资保函、中标贷将陆续开通申请。
            </div>
          </div>
          <div class="advantageItem">
            <div class="imgIcon">
              <img
                class="itemicon"
                src="../../assets/images/aboutUs/shield.png"
              />
            </div>
            <div class="title"><h3>担保机构多</h3></div>
            <div class="detail">
              入驻和对接的合作方式，包容性强，可提供担保的机构多，投标人的选择也多。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
}
</script>

<style scoped lang="scss">
.top {
  background: url('../../assets/images/aboutUs/bg1.png') no-repeat;
  height: 280px;
  background-size: 100% 100%;
  display: flex;
  color: #ffffff;
}
.left {
  width: 15%;
  height: 100%;
  /*line-height: 280px;*/
  font-size: 24px;
  color: #ffffff;
  text-align: left;
  display: inline-block;
  padding: 4% 0;
  position: absolute;
}
.right {
  text-align: left;
  color: #ffffff;
  width: 85%;
  line-height: 20px;
  display: inline-block;
  vertical-align: text-top;
  padding: 4% 0;
  position: absolute;
  left: 15%;
  height: 100%;
}
.center {
  /*background: url("../../assets/images/aboutUs/bg2.png") no-repeat;*/
  min-height: 280px;
  background-size: 100% 100%;
  display: flex;
  background-color: #edf5fa;
}
.description div:first-child {
  font-size: 24px;
}
.description div:last-child {
  font-size: 14px;
  text-align: left;
  line-height: 30px;
}
.description {
  width: 35%;
  /*margin-left: 10%;*/
  height: 283px;
  padding: 23px 0px;
  text-align: left;
  vertical-align: middle;
  display: table-cell;
  float: left;
  display: inline-block;
}
.textTips {
  /*display: table-cell;*/
  /*vertical-align: middle;*/
  /*height: 283px;*/
}
.advantage {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
}
.advantageItem {
  text-align: center;
  .detail {
    width: 50%;
    margin: 0 auto;
  }
}
.imgIcon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  padding: 10px;
  .itemicon {
    width: 100%;
    height: 100%;
  }
}
.footer {
  background-color: #ffffff;
}
.bgClass {
  width: 65%;
  height: 100%;
  display: inline-block;
  img {
    width: 592px;
    height: 284px;
    float: right;
  }
}
</style>
